import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from "@metsooutotec/modes-react-components";
export var NotFound = function (_a) {
    var id = _a.id;
    var compId = id !== null && id !== void 0 ? id : "Id.NotFound";
    return _jsx(FormattedMessage, { id: compId, defaultValue: compId });
};
